export default __webpack_public_path__ + "static/media/right_ans.633657ca.svg";